<template>
    <div class="wrapper">
        <router-view></router-view>
        <h1 class="orange">Inspirationen</h1>
        <div class="inspirations">
            <a :href="'inspirations/' + inspiration.slug" class="card textcard card--orange" v-for="inspiration in inspirations" :key="inspiration.id">
                <div class="card__image">
                    <div :style="{ 'background-image': 'url(\'' + inspiration.image[0].url + '\')' }"></div>
                </div>
                <div class="card__content">
                    <h2>{{ inspiration.title }}</h2>
                    <p class="title-thin">{{ inspiration.lead }}</p>
                    <p>Schauen Sie sich das Video an</p>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            inspirations(){
                return this.$store.state.inspirations.inspirations
            }
        }
    }
</script>

<style scoped lang="scss">
    .inspirations {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 70px;
    }
    .title-thin {
        font-weight: 300;
    }

    @media (max-width: 950px){
        .inspirations {
            display: block;
        }
    }
</style>
